import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ImprovedDashboardComponent } from './components/improved-dashboard/improved-dashboard.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    { path: 'dashboard', component: ImprovedDashboardComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}
